import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import data from '../data/kataMereka.json';
import '../css/testimoni.css';
import 'animate.css';
import { Link } from "react-router-dom";

export default function CarouselTesti() {
    const [jsonData, setJsonData] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        setJsonData(data);
        const interval = setInterval(() => {
            setActiveIndex((prevIndex) => (prevIndex + 1) % jsonData.length);
        }, 2500); // Interval setiap 1 detik

        return () => clearInterval(interval);
    }, [jsonData.length]);

    return (
        <div id="carouselExampleCaptions" className="carousel sliders mt-4" style={{ width: "100%", borderRadius: "10px", height: "auto" }} data-bs-ride="carousel">
            <div className="carousel-indicators">
                {jsonData.map((item, index) => (
                    <button key={index} type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide-to={index} className={index === activeIndex ? "active" : ""} aria-current={index === activeIndex ? "true" : ""} aria-label={`Slide ${index + 1}`}></button>
                ))}
            </div>
            <div className="carousel-inner">
                {jsonData.map((item, index) => (
                    <div key={index} className={`carousel-item ${index === activeIndex ? "active" : ""} ${index === activeIndex ? "carousel-item-start" : ""}`}>
                        <a style={{padding: "50px"}}>
                            <div className="covtes">
                                <h1 className="kata" style={{textDecoration: "none", color: "black"}}>{item.say}</h1>
                                <Link to={`/detailTesti/${index}`} className="lengkap">Lihat selengkapnya</Link>
                                <div className="profil d-flex align-items-start gap-3">
                                    <img src={item.img} alt="Profile" className="p-testi" />
                                    <div>
                                        <h1 className="nama">{item.nama}</h1>
                                        <p>Wali dari <span className="wali">{item.wali}</span>/ {item.kls}</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                ))}
            </div>
            <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev" style={{ marginLeft: "10px" }} onClick={() => setActiveIndex((activeIndex - 1 + jsonData.length) % jsonData.length)}>
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next" style={{ marginRight: "10px" }} onClick={() => setActiveIndex((activeIndex + 1) % jsonData.length)}>
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
            </button>
        </div>
    )
}
